import React, { useMemo } from "react";
import { Layout, Menu } from "antd";
import { PieChartOutlined } from "@ant-design/icons";
import TopBar from "./Topbar";
import { Link, Outlet, useLocation } from "react-router-dom";
import { ROUTES } from "./common";
import { useUser } from "../context";

const { Header, Content, Footer, Sider } = Layout;

interface Path {
  label: string;
  value: string;
  icon: React.ReactNode;
}

const commonPaths: Path[] = [
  { label: "Dashboard", value: ROUTES.DASHBOARD, icon: <PieChartOutlined /> },
];

export const SideLayout = () => {
  const { user } = useUser();
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = React.useState(false);
  const onCollapse = (val: boolean) => setCollapsed(val);

  const selectedKey = useMemo(() => {
    const path = commonPaths.find((e) => e.value === pathname);
    if (path) return path.value;
    return "/dashboard";
  }, [pathname]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
        <div className="logo" />
        <Menu theme="dark" mode="inline" selectedKeys={[selectedKey]} className="sidebar-menu">
          {commonPaths.map((path) => (
            <Menu.Item key={path.value} icon={path.icon}>
              <Link to={path.value}>{path.label}</Link>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header className="site-layout-background" style={{ padding: 0 }}>
          <TopBar />
        </Header>
        <Content style={{ maxHeight: "calc(100vh - 125px)", overflow: "auto" }}>
          <Outlet />
        </Content>
        <Footer style={{ textAlign: "center" }}>
          Dashboard ©2026 Created by ChronoFlow
        </Footer>
      </Layout>
    </Layout>
  );
};
